/**
 * "Take a photo with your phone" — the desktop chat's hand-off of THIS conversation to the phone's camera.
 *
 * A desktop has no camera roll, and the photo someone wants to send is usually in front of them (a receipt,
 * a whiteboard, a letter). Both phones already open a chat by id from `symphony.wix.app/chat/<id>`; the
 * `attach=camera` parameter asks them to open that chat's camera on arrival, so one scan puts the camera in
 * the same conversation the desktop is showing. The photo is sent from the phone's composer as usual, and
 * the desktop draws it live (see `liveChatRowKind`).
 *
 * The link resolves the same way on all three surfaces — the per-link tables pin it: iOS `DeepLinkTests`,
 * Android `DeeplinkResolutionTest`, web `web-link-parity.test.ts`. Web opens the conversation and ignores
 * `attach`: the code is only ever scanned by a phone, and a desktop that follows it has no camera to open.
 *
 * `symphony.wix.app` rather than the web host: it is the app-link domain both phones claim, and it sends a
 * phone without the app to the install page instead of a web page that cannot take a photo.
 */
export const PHONE_PHOTO_ATTACH_PARAM = 'attach';
export const PHONE_PHOTO_ATTACH_CAMERA = 'camera';

const APP_LINK_HOST = 'https://symphony.wix.app';

export function phonePhotoHandoffLink(conversationId: string): string {
  return `${APP_LINK_HOST}/chat/${encodeURIComponent(conversationId)}?${PHONE_PHOTO_ATTACH_PARAM}=${PHONE_PHOTO_ATTACH_CAMERA}`;
}
